import React from "react";
import { Button, EmptyState, Skeleton } from "../ui";
import "../../styles/content.css";

export function Switch({ checked, onChange, label }) {
  return <span className="switch"><input type="checkbox" role="switch" aria-label={label} checked={!!checked} onChange={(e) => onChange(e.target.checked)} /><i /></span>;
}

export const when = (iso) => {
  const d = new Date(iso);
  return iso && !Number.isNaN(d.getTime()) ? d.toLocaleString("th-TH", { dateStyle: "medium", timeStyle: "short" }) : "-";
};

/** ตารางข้อมูลแอดมิน: columns [{key,label,render?}] ; แถว is-off เมื่อ isActive === false */
export function DataTable({ columns, rows, loading, error, empty = "ไม่มีข้อมูล", onRetry, hasMore, onMore, moreLoading, rowKey = "id" }) {
  if (error) return <EmptyState icon="⚠️" title="โหลดไม่สำเร็จ" action={onRetry ? <Button onClick={onRetry}>ลองใหม่</Button> : null}><span className="error-text">{error}</span></EmptyState>;
  if (loading) return <div className="stack">{Array.from({ length: 5 }, (_, i) => <Skeleton key={i} height={40} />)}</div>;
  if (!rows.length) return <EmptyState icon="📭" title={empty} />;
  return (
    <>
      <div className="table-wrap card" style={{ padding: 0 }}>
        <table className="table">
          <thead><tr>{columns.map((c) => <th key={c.key} scope="col">{c.label}</th>)}</tr></thead>
          <tbody>{rows.map((r) => <tr key={r[rowKey]} className={r.isActive === false ? "is-off" : ""}>{columns.map((c) => <td key={c.key}>{c.render ? c.render(r) : String(r[c.key] ?? "-")}</td>)}</tr>)}</tbody>
        </table>
      </div>
      {hasMore ? <div className="center mt-16"><Button onClick={onMore} disabled={moreLoading}>{moreLoading ? "กำลังโหลด..." : "โหลดเพิ่ม"}</Button></div> : null}
    </>
  );
}
